import U from "vue-airbnb-style-datepicker";
import { ref as s, computed as c, watch as Y, onMounted as G, onBeforeUnmount as J, resolveComponent as K, openBlock as S, createElementBlock as k, normalizeClass as Q, createElementVNode as d, renderSlot as W, toDisplayString as f, createCommentVNode as E, createVNode as u, withCtx as m, unref as v } from "vue";
import P from "date-fns/format/index.js";
import Z from "date-fns/is_same_year/index.js";
import { IconArrowLeft as _, IconArrowRight as ee, IconXLg as te, IconXSm as ae } from "@rei/cedar";
const ne = {
  class: "date-picker-dates-label"
}, oe = {
  class: "sr-only"
}, le = {
  "aria-hidden": "true"
}, re = ["id", "aria-expanded"], se = {
  key: 0,
  "aria-hidden": "true",
  class: "date-picker-trigger-separator"
}, ie = {
  name: "DatePicker"
}, A = /* @__PURE__ */ Object.assign(ie, {
  props: {
    triggerLabel: {
      type: String,
      required: !1,
      // user should pass either a triggerLabel or a slot named triggerLabel
      default: "Select dates"
    },
    changeDatesLabel: {
      type: String,
      required: !1,
      default: "Select date range"
    },
    removeDatesLabel: {
      type: String,
      required: !1,
      default: "Remove"
    },
    triggerElementId: {
      type: String,
      default: "date-picker-trigger"
    },
    dateOne: {
      type: [String, Date],
      default: null
    },
    dateTwo: {
      type: [String, Date],
      default: null
    },
    minDate: {
      type: [String, Date],
      default: null
    },
    endDate: {
      type: [String, Date],
      default: null
    },
    mode: {
      type: String,
      default: "range"
    },
    offsetY: {
      type: Number,
      default: 0
    },
    offsetX: {
      type: Number,
      default: 0
    },
    monthsToShow: {
      type: Number,
      default: 2
    },
    startOpen: {
      type: Boolean
    },
    fullscreenMobile: {
      type: Boolean
    },
    inline: {
      type: Boolean
    },
    mobileHeader: {
      type: String,
      default: null
    },
    disabledDates: {
      type: Array,
      default: () => []
    },
    showActionButtons: {
      type: Boolean,
      default: !0
    },
    showShortcutsMenuTrigger: {
      type: Boolean,
      default: !1
    },
    showMonthYearSelect: {
      type: Boolean,
      default: !1
    },
    trigger: {
      type: Boolean,
      default: !1
    },
    // Desired copy for "Apply" button text per Adventures UX: https://issues.rei.com/browse/ADV-2366
    applyButtonEnabledText: {
      type: String,
      required: !1,
      default: "Search these dates"
    },
    applyButtonDisabledText: {
      type: String,
      required: !1,
      default: "Select dates to continue"
    }
  },
  emits: ["date-one-selected", "date-two-selected", "remove-dates", "opened", "closed", "cancelled", "apply", "previous-month", "next-month"],
  setup(e, {
    emit: g
  }) {
    const n = e, l = g, o = s(n.dateOne), a = s(n.dateTwo), h = s("false"), M = s(!1), i = s(null), p = s(null), x = c(() => B("MMM D", "MMM D, YYYY", "-")), T = c(() => B("MMMM Do", "MMMM Do, YYYY", "to")), b = c(() => o.value || a.value), C = c(() => b.value ? n.changeDatesLabel : n.triggerLabel);
    Y(() => n.dateOne, (t) => {
      o.value = t;
    }), Y(() => n.dateTwo, (t) => {
      a.value = t;
    }), G(() => {
      i.value.addEventListener("touchstart", y), w();
    }), J(() => {
      i.value.removeEventListener("touchstart", y);
    });
    function y() {
      i.value.removeEventListener("touchstart", y), M.value = !0;
    }
    function B(t, r, D) {
      let O = "";
      const z = Z(o.value, a.value), F = a.value && z ? t : r;
      o.value && (O = P(o.value, F));
      let L = "";
      return a.value && (L = ` ${D} ${P(a.value, r)}`), `${O}${L}`;
    }
    function I(t) {
      o.value = t, l("date-one-selected", t), w();
    }
    function N(t) {
      a.value = t, l("date-two-selected", t), w();
    }
    function q() {
      o.value = "", a.value = "", l("remove-dates");
    }
    function $() {
      h.value = "true", l("opened");
    }
    function R() {
      o.value && a.value || (o.value = n.dateOne, a.value = n.dateTwo), h.value = "false", l("closed", o.value, a.value);
    }
    function X() {
      o.value = n.dateOne, a.value = n.dateTwo, l("cancelled");
    }
    function V() {
      l("apply", o.value, a.value);
    }
    function H(t) {
      l("previous-month", t);
    }
    function j(t) {
      l("next-month", t);
    }
    function w() {
      const t = i.value.querySelector(".asd__action-buttons"), r = t && t.children[1];
      r && (o.value && a.value ? (r.disabled = !1, p.value.texts.apply = n.applyButtonEnabledText) : (r.disabled = !0, p.value.texts.apply = n.applyButtonDisabledText));
    }
    return (t, r) => {
      const D = K("airbnb-style-datepicker");
      return S(), k("div", {
        ref_key: "datePicker",
        ref: i,
        class: Q({
          "datepicker-trigger": !0,
          asd__hover: !M.value
        })
      }, [d("div", null, [d("div", ne, [W(t.$slots, "label", {
        ariaLabel: T.value,
        label: x.value
      }, () => [d("span", oe, f(T.value), 1), d("span", le, f(x.value), 1)])]), d("button", {
        id: e.triggerElementId,
        "aria-expanded": h.value,
        class: "date-picker-trigger-text date-picker-change"
      }, f(C.value), 9, re), b.value ? (S(), k("span", se, "•")) : E("", !0), b.value ? (S(), k("button", {
        key: 1,
        class: "date-picker-trigger-text date-picker-remove",
        onClick: q
      }, f(e.removeDatesLabel), 1)) : E("", !0)]), u(D, {
        ref_key: "airbnbDatePicker",
        ref: p,
        "trigger-element-id": e.triggerElementId,
        "date-one": e.dateOne,
        "date-two": e.dateTwo,
        "min-date": e.minDate,
        "end-date": e.endDate,
        mode: e.mode,
        "offset-y": e.offsetY,
        "offset-x": e.offsetX,
        "months-to-show": e.monthsToShow,
        "start-open": e.startOpen,
        "fullscreen-mobile": e.fullscreenMobile,
        inline: e.inline,
        "mobile-header": e.mobileHeader,
        "disabled-dates": e.disabledDates,
        "show-action-buttons": e.showActionButtons,
        "show-shortcuts-menu-trigger": e.showShortcutsMenuTrigger,
        "show-month-year-select": e.showMonthYearSelect,
        trigger: e.trigger,
        onDateOneSelected: I,
        onDateTwoSelected: N,
        onOpened: $,
        onClosed: R,
        onCancelled: X,
        onApply: V,
        onPreviousMonth: H,
        onNextMonth: j
      }, {
        "previous-month-icon": m(() => [u(v(_))]),
        "next-month-icon": m(() => [u(v(ee))]),
        "close-icon": m(() => [u(v(te))]),
        "close-shortcuts-icon": m(() => [u(v(ae))]),
        _: 1
      }, 8, ["trigger-element-id", "date-one", "date-two", "min-date", "end-date", "mode", "offset-y", "offset-x", "months-to-show", "start-open", "fullscreen-mobile", "inline", "mobile-header", "disabled-dates", "show-action-buttons", "show-shortcuts-menu-trigger", "show-month-year-select", "trigger"])], 2);
    };
  }
}), ve = {
  install(e, g) {
    const l = { ...{
      sundayFirst: !0
    }, ...g };
    e.use(U, l), e.component(A.name || "DatePicker", A);
  }
};
export {
  ve as default
};
